import { FC } from 'react';
import SkapaSwitch from '@ingka/switch';

export const Switch: FC<{
  id: string;
  label: any;
  value: boolean;
  onChange: (value: boolean) => void;
}> = ({ id, label, value, onChange }) => (
  <SkapaSwitch
    checked={value}
    className="items-center"
    id={id}
    label={label}
    value={''}
    data-testid={id}
    onChange={(event) => {
      onChange(event.target.checked);
    }}
  />
);
